import React from 'react';

import { ListingsContext } from '@kamernet/modules/Listing/context/ListingsContext';

import { SearchView } from '../../types';

export const useListingSelectors = () => {
  const { listingsState } = ListingsContext.useContext();

  const getTotalListingsCount = React.useCallback(() => {
    return listingsState.listingsResult.listings.total || 0;
  }, [listingsState.listingsResult.listings.total]);

  const getNormalListingsCount = React.useCallback(() => {
    const { listings } = listingsState.listingsResult;

    if (!listings || listings.total === undefined) {
      return 0;
    }

    const topAdListingsCount = listings.topAdListings
      ? listings.topAdListings.length
      : 0;

    return listings.total - topAdListingsCount;
  }, [listingsState.listingsResult]);

  const getListings = () => {
    return listingsState.listingsResult.listings.listings;
  };

  const getFeaturedListings = () => {
    if (listingsState.filterResult.filters.searchview === SearchView.Map) {
      return [];
    }
    return listingsState.listingsResult.listings.topAdListings;
  };

  const getNearbyListings = () => {
    if (listingsState.filterResult.filters.searchview === SearchView.Map) {
      return [];
    }
    return listingsState.listingsResult.listings.nearbyListings;
  };

  const isLoading = () => {
    return listingsState.listingsResult.isLoading;
  };

  return {
    getTotalListingsCount,
    getNormalListingsCount,
    getListings,
    getFeaturedListings,
    getNearbyListings,
    isLoading,
  };
};
